import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const productionOrderDetailsQueryKey = (productionOrderId?: number) => [
  'production-order-details',
  productionOrderId,
];

export const useProductionOrderDetails = (productionOrderId?: number) => {
  const api = useAPI();

  return useQuery({
    queryKey: productionOrderDetailsQueryKey(productionOrderId),
    queryFn: () =>
      api.getBackProductionOrderDetailsProductionorderid({
        productionOrderId: productionOrderId!,
      }),
    enabled: !!productionOrderId,
  });
};
